import { Duplexer } from '@wix/duplexer-js';

import { renderModel } from '../../util/renderModel';

let duplexerInstance: Duplexer;

// Returns singleton instance of Duplexer created on demand.
export const useDuplexerInstance = () => {
  if (!duplexerInstance) {
    const { duplexer, authorizationToken } = renderModel.get();
    const { duplexerURL } = duplexer;

    duplexerInstance = new Duplexer(duplexerURL, {
      instanceUpdater: {
        getInstance: () => authorizationToken || '',
      },
    });
  }

  return duplexerInstance;
};
